export default {
  categories: 'Kategorien',
  segments: 'Segmente',
  businesses: 'Business',
  active: 'aktiv',
  inactive: 'Inaktiv',
  noBusinessesCreated: 'Es wurden keine Unternehmen gegründet',
  newBusiness: 'Neugeschäft',
  editBusiness: 'Bearbeiten des Geschäfts',
  businessUrl: 'Geschäfts-URL',
  segment: 'Segment',
  insertExtraDataName: 'Geben Sie den Namen der zusätzlichen Daten ein',
  insertExtraDataValues: 'Geben Sie die Werte der zusätzlichen Daten ein',
  delete: 'Löschen',
  addExtraData: 'Hinzufügen zusätzlicher Daten',
  businessSuccessfullyCreated: 'Erfolgreich geschaffenes Unternehmen',
  businessSuccessfullyEdited: 'Geschäft korrekt geändert',
  addNewBusiness: 'Hinzufügen von neuem Unternehmen',
  uploadPhoto: 'Foto hochladen',
  doYouWantToDeleteThisContact: 'Möchten Sie diesen Kontakt löschen?',
  deleteContact: 'Klarer Kontakt',
  contactSuccessfullyDeleted: 'Kontakt wurde erfolgreich gelöscht',
  doYouWantToDeleteThisBusiness: 'Möchten Sie dieses Geschäft löschen?',
  deleteBusiness: 'Klares Geschäft',
  businessSuccessfullyDeleted: 'Unternehmen korrekt ausgegwässt',
  errorLoadingTheBusiness: 'Beim Laden des Unternehmens ist ein Fehler aufgetreten.',
  addContact: 'Kontakt hinzufügen',
  nameOfTheBusiness: 'Firmenname',
  noCategories: 'Keine Kategorien',
  noLocation: 'Kein Standort',
  noAddress: 'Keine Adresse',
  noSegment: 'Kein Segment',
  contactSuccessfullyAdded: 'Kontakt korrekt hinzugefügt',
  contacts: 'Kontakte',
  noRoles: 'Keine Rollen',
  loadingBusinessContacts: 'Laden von Geschäftskontakten',
  noBusinessContacts: 'Dieses Unternehmen hat keine Kontakte'
}
